<template>
  <div style="background-color: #212121; min-height: 100vh" class="pa-2 pa-md-4">
    <div v-if="startOfMonth" class="white--text">
      <v-card-title class="text-h5 font-weight-black px-2 mb-4 d-flex align-center">
        <v-icon left color="primary" large>mdi-view-dashboard</v-icon>
        Überblick Center
      </v-card-title>

      <v-row dense>
        <v-col cols="12" sm="6" md="4" lg="2">
          <v-card dark class="dashboard-card fill-height rounded-xl pa-4" color="#2A2A2A" elevation="4">
            <div class="d-flex justify-space-between align-start mb-2">
              <span class="card-label">Mitglieder ({{ $moment(datePickerRange[0]).format("DD.MMM") }})</span>
              <v-avatar color="rgba(0, 201, 167, 0.1)" size="32">
                <v-icon color="#00c9a7" small>mdi-account-group</v-icon>
              </v-avatar>
            </div>
            <div class="text-h4 font-weight-black mt-auto">
              <number :to="parseFloat(Number(startOfMonth.customersAmount.tac.customers.total).toFixed(2) || 0)"></number>
            </div>
            <div class="accent-line" style="background: #00c9a7"></div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="2">
          <v-card dark class="dashboard-card fill-height rounded-xl pa-4" color="#2A2A2A" elevation="4">
            <div class="d-flex justify-space-between align-start mb-2">
              <span class="card-label">Kündigungen</span>
              <v-avatar color="rgba(255, 0, 0, 0.1)" size="32">
                <v-icon color="red" small>mdi-account-remove</v-icon>
              </v-avatar>
            </div>
            <div v-if="finishedLoadingTerminations" class="text-h4 font-weight-black mt-auto">
              <number :to="parseFloat(Number(terminations).toFixed(2) || 0)"></number>
            </div>
            <v-progress-circular v-else indeterminate color="red" size="24"></v-progress-circular>
            <div class="accent-line" style="background: red"></div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="2">
          <v-card dark class="dashboard-card fill-height rounded-xl pa-4" color="#2A2A2A" elevation="4">
            <div class="d-flex justify-space-between align-start mb-2">
              <span class="card-label">Neu Verträge</span>
              <v-avatar color="rgba(33, 150, 243, 0.1)" size="32">
                <v-icon color="primary" small>mdi-file-document-edit</v-icon>
              </v-avatar>
            </div>
            <div v-if="finishedLoading" class="text-h4 font-weight-black mt-auto">
              <number :to="parseFloat(Number(newContracts.totalContracts).toFixed(2) || 0)"></number>
            </div>
            <v-progress-circular v-else indeterminate color="primary" size="24"></v-progress-circular>
            <div class="accent-line" style="background: var(--v-primary-base, #1976d2)"></div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="2">
          <v-card dark class="dashboard-card fill-height rounded-xl pa-4" color="#2A2A2A" elevation="4">
            <div class="d-flex justify-space-between align-start mb-2">
              <span class="card-label">Online Verträge</span>
              <v-avatar color="rgba(255, 152, 0, 0.1)" size="32">
                <v-icon color="orange" small>mdi-laptop</v-icon>
              </v-avatar>
            </div>
            <div v-if="finishedLoading" class="text-h4 font-weight-black mt-auto">
              <number :to="parseFloat(Number(newContracts.publicContracts).toFixed(2) || 0)"></number>
            </div>
            <v-progress-circular v-else indeterminate color="orange" size="24"></v-progress-circular>
            <div class="accent-line" style="background: orange"></div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="2">
          <v-card dark class="dashboard-card fill-height rounded-xl pa-4" color="#2A2A2A" elevation="4">
            <div class="d-flex justify-space-between align-start mb-2">
              <span class="card-label">Soll Wachstum</span>
              <v-avatar color="rgba(0, 175, 166, 0.1)" size="32">
                <v-icon color="#00afa6" small>mdi-trending-up</v-icon>
              </v-avatar>
            </div>
            <div class="text-h4 font-weight-black mt-auto">
              <number :to="parseFloat(Number(growthForMonth).toFixed(2) || 0)"></number>
            </div>
            <div class="accent-line" style="background: #00afa6"></div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="2">
          <v-card dark class="dashboard-card fill-height rounded-xl pa-4" color="#2A2A2A" elevation="4">
            <div class="d-flex justify-space-between align-start mb-2">
              <span class="card-label">IST Wachstum</span>
              <v-avatar color="rgba(0, 175, 166, 0.1)" size="32">
                <v-icon color="#00afa6" small>mdi-finance</v-icon>
              </v-avatar>
            </div>
            <div v-if="finishedLoadingTerminations" class="text-h4 font-weight-black mt-auto">
              <number :to="parseFloat(Number(newContracts.totalContracts - terminations).toFixed(2) || 0)"></number>
            </div>
            <v-progress-circular v-else indeterminate color="#00afa6" size="24"></v-progress-circular>
            <div class="accent-line" style="background: #00afa6"></div>
          </v-card>
        </v-col>
      </v-row>

      <v-row dense class="mt-4">
        <v-col cols="12" sm="6" md="4" lg="2">
          <v-card dark class="dashboard-card fill-height rounded-xl pa-4" color="#2A2A2A" elevation="4">
            <div class="d-flex justify-space-between align-start mb-2">
              <span class="card-label">Quadratmeter</span>
              <v-avatar color="rgba(1, 122, 139, 0.1)" size="32">
                <v-icon color="#017a8b" small>mdi-texture-box</v-icon>
              </v-avatar>
            </div>
            <div class="text-h4 font-weight-black d-flex align-baseline mt-auto">
              <number :to="parseFloat(Number(startOfMonth.customersAmount.tac.squareMeter.squareMeterAmount).toFixed(2) || 0)"></number>
              <span class="text-subtitle-1 grey--text ml-1">m²</span>
            </div>
            <div class="accent-line" style="background: #017a8b"></div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="2">
          <v-card dark class="dashboard-card fill-height rounded-xl pa-4" color="#2A2A2A" elevation="4">
            <div class="d-flex justify-space-between align-start mb-2">
              <span class="card-label">Mitglieder / m²</span>
              <v-avatar color="rgba(1, 122, 139, 0.1)" size="32">
                <v-icon color="#017a8b" small>mdi-human-capacity-increase</v-icon>
              </v-avatar>
            </div>
            <div class="text-h4 font-weight-black mt-auto">
              {{ Number(startOfMonth.customersAmount.tac.squareMeter.customerAmount).toFixed(2) }}
            </div>
            <div class="accent-line" style="background: #017a8b"></div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="2">
          <v-card dark class="dashboard-card fill-height rounded-xl pa-4" color="#2A2A2A" elevation="4">
            <div class="d-flex justify-space-between align-start mb-2">
              <span class="card-label">Stellen % ({{ $moment(datePickerRange[0]).format("DD.MM") }})</span>
              <v-avatar color="rgba(38, 96, 116, 0.1)" size="32">
                <v-icon color="#266074" small>mdi-briefcase-clock</v-icon>
              </v-avatar>
            </div>
            <div class="text-h4 font-weight-black mt-auto">
              <number :to="parseFloat(Number(startOfMonth.customersAmount.tac.percentage.percentageAmount).toFixed(2) || 0)"></number>%
            </div>
            <div class="accent-line" style="background: #266074"></div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="3">
          <v-card dark class="dashboard-card fill-height rounded-xl pa-4" color="#2A2A2A" elevation="4">
            <div class="d-flex justify-space-between align-start mb-2">
              <span class="card-label">Stellen % Aktuell</span>
              <v-avatar color="rgba(38, 96, 116, 0.1)" size="32">
                <v-icon color="#266074" small>mdi-briefcase-check</v-icon>
              </v-avatar>
            </div>
            <div class="text-h4 font-weight-black mt-auto"><number :to="parseFloat(Number(totalPercentages).toFixed(2) || 0)"></number>%</div>
            <div class="accent-line" style="background: #266074"></div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="3">
          <v-card dark class="dashboard-card fill-height rounded-xl pa-4" color="#2A2A2A" elevation="4">
            <div class="d-flex justify-space-between align-start mb-2">
              <span class="card-label">Mitglieder pro 100%</span>
              <v-avatar color="rgba(38, 96, 116, 0.1)" size="32">
                <v-icon color="#266074" small>mdi-account-multiple-check</v-icon>
              </v-avatar>
            </div>
            <div class="text-h4 font-weight-black mt-auto">
              <number :to="parseFloat(Number(startOfMonth.customersAmount.tac.percentage.customerAmount * 100).toFixed(2) || 0)"></number>
            </div>
            <div class="accent-line" style="background: #266074"></div>
          </v-card>
        </v-col>
      </v-row>

      <v-card-title class="text-h6 font-weight-bold px-2 mt-8 mb-2 d-flex align-center flex-wrap">
        Monatsziele der Trainer
        <v-spacer></v-spacer>
        <v-btn color="primary" small rounded class="mt-2 mt-sm-0" @click="openTrainerSelectDialog">
          <v-icon left small>mdi-flag-checkered</v-icon> Ziele bearbeiten
        </v-btn>
      </v-card-title>

      <v-data-table
        dark
        :mobile-breakpoint="mobileTableMode"
        :search="search"
        :loading="!finishedLoading"
        :headers="groupfitnessCoursesTable"
        no-data-text="Keine Trainer gefunden..."
        loading-text="Trainerstatistiken werden geladen..."
        :items="filteredDashboardTrainerInfos"
        :items-per-page="8"
        class="elevation-4 rounded-xl modern-table overflow-hidden"
        style="background-color: #2a2a2a">
        <template v-slot:top>
          <v-row class="pa-4" align="center">
            <v-col cols="12" sm="7" md="6" class="d-flex align-center">
              <v-text-field
                dark
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                label="Suche nach Trainer..."
                outlined
                dense
                hide-details
                color="primary"></v-text-field>
              <v-btn v-if="$vuetify.breakpoint.mobile" icon color="primary" class="ml-3" @click="toggleMobileTableMode">
                <v-icon>mdi-table-sync</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" sm="5" md="6" class="text-right">
              <v-tooltip bottom>
                <div class="d-flex flex-column pa-2 white--text">
                  <span class="font-weight-bold mb-1">Ausgeblendete Mitarbeiter:</span>
                  <p v-for="trainer of notShownTrainers" :key="'notshown' + trainer._id" class="mb-0 text-caption">
                    {{ trainer.fullName }}
                  </p>
                  <span v-if="!notShownTrainers.length">Niemand ausgeblendet</span>
                </div>
                <template v-slot:activator="{ props, on }">
                  <v-btn v-bind="props" v-on="on" icon color="grey"><v-icon>mdi-information-outline</v-icon></v-btn>
                </template>
              </v-tooltip>
            </v-col>
          </v-row>
        </template>

        <template v-slot:item.percentage="{ item }">
          <v-tooltip bottom>
            <div class="d-flex flex-column white--text">
              <span v-for="(pItem, idx) in item.allPercentages" :key="pItem._id + item.fullName + idx">
                {{ (storeStudios.find((s) => s._id === pItem._id)?.name || "zus. Team") + ": " + Number(pItem.percentage).toFixed(2) + "%" }}
              </span>
            </div>
            <template v-slot:activator="{ props, on }">
              <v-chip color="rgba(255,255,255,0.1)" v-bind="props" v-on="on" class="font-weight-bold" dark
                >{{ Number(item.percentage).toFixed(2) }}%</v-chip
              >
            </template>
          </v-tooltip>
        </template>

        <template v-slot:item.contracts="{ item }">
          <v-tooltip bottom>
            <div class="white--text">
              <p v-for="(count, name) in item.studios" :key="name" class="mb-0">{{ name }}: {{ Number(count).toFixed(2) }}</p>
            </div>
            <template v-slot:activator="{ props, on }">
              <v-chip
                v-bind="props"
                v-on="on"
                :color="getTargetColor(item.contracts, item.trainerGoal?.goals.contracts)"
                class="font-weight-bold"
                dark>
                {{ Number(item.contracts).toFixed(2) }} /
                {{ item.trainerGoal?.goals.contracts != null ? Number(item.trainerGoal.goals.contracts).toFixed(2) : "-" }}
              </v-chip>
            </template>
          </v-tooltip>
        </template>

        <template v-slot:item.avgPackages="{ item }">
          <v-tooltip bottom>
            <div class="white--text">
              <p class="mb-0">Gesamt verkauft: {{ (item.avgPackages * item.contracts).toFixed(2) }}</p>
            </div>
            <template v-slot:activator="{ props, on }">
              <v-chip v-bind="props" v-on="on" :color="getPackageColor(item.avgPackages)" class="font-weight-bold" dark>
                {{ Number(item.avgPackages).toFixed(2) }}
              </v-chip>
            </template>
          </v-tooltip>
        </template>

        <template v-slot:item.packageCount="{ item }">
          <v-chip :color="getTargetColor(item.packageCount, item.trainerGoal?.goals.packages)" class="font-weight-bold" dark>
            {{ Number(item.packageCount).toFixed(2) }} /
            {{ item.trainerGoal?.goals.packages != null ? Number(item.trainerGoal.goals.packages).toFixed(2) : "-" }}
          </v-chip>
        </template>

        <template v-slot:item.medicalHistory="{ item }">
          <v-chip :color="getTargetColor(item.medicalHistory, item.trainerGoal?.goals.anamneses)" class="font-weight-bold" dark>
            {{ Number(item.medicalHistory).toFixed(2) }} /
            {{ item.trainerGoal?.goals.anamneses != null ? Number(item.trainerGoal.goals.anamneses).toFixed(2) : "-" }}
          </v-chip>
        </template>

        <template v-slot:item.workouts="{ item }">
          <v-chip :color="getTargetColor(item.workouts, item.trainerGoal?.goals.workouts)" class="font-weight-bold" dark>
            {{ Number(item.workouts).toFixed(2) }} /
            {{ item.trainerGoal?.goals.workouts != null ? Number(item.trainerGoal.goals.workouts).toFixed(2) : "-" }}
          </v-chip>
        </template>

        <template v-slot:item.workoutsPerCustomer="{ item }">
          <v-chip :color="getTargetColor(item.workoutsPerCustomer, item.trainerGoal?.goals.workoutsPerCustomer)" class="font-weight-bold" dark>
            {{ Number(item.workoutsPerCustomer).toFixed(2) }} /
            {{ item.trainerGoal?.goals.workoutsPerCustomer != null ? Number(item.trainerGoal.goals.workoutsPerCustomer).toFixed(2) : "-" }}
          </v-chip>
        </template>

        <template v-slot:item.interactions.totalInteractions="{ item }">
          <v-chip :color="getTargetColor(item.interactions.totalInteractions, item.trainerGoal?.goals.interactions)" class="font-weight-bold" dark>
            {{ Number(item.interactions.totalInteractions).toFixed(2) }} /
            {{ item.trainerGoal?.goals.interactions != null ? Number(item.trainerGoal.goals.interactions).toFixed(2) : "-" }}
          </v-chip>
        </template>

        <template v-slot:item.appointments="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                v-bind="attrs"
                v-on="on"
                :color="getTargetColor(appointmentActual(item), item.trainerGoal?.goals.appointmentsTarget)"
                class="font-weight-bold"
                dark>
                {{ Number(appointmentActual(item)).toFixed(2) }} /
                {{ item.trainerGoal?.goals.appointmentsTarget != null ? Number(item.trainerGoal.goals.appointmentsTarget).toFixed(2) : "-" }}
                <v-icon x-small right>{{ appointmentSourceIcon(item) }}</v-icon>
              </v-chip>
            </template>
            <span>{{ appointmentSourceLabel(item) }} · alle Termine ausser storniert</span>
          </v-tooltip>
        </template>

        <template v-slot:item.upgrades="{ item }">
          <v-chip :color="getTargetColor(item.upgrades, item.trainerGoal?.goals.upgrades)" class="font-weight-bold" dark>
            {{ Number(item.upgrades).toFixed(2) }} /
            {{ item.trainerGoal?.goals.upgrades != null ? Number(item.trainerGoal.goals.upgrades).toFixed(2) : "-" }}
          </v-chip>
        </template>
      </v-data-table>

      <v-card-title class="text-h6 font-weight-bold px-2 mt-8 mb-2">
        11-Tage-Statistiken
        <v-chip small class="ml-3 font-weight-bold" color="rgba(255,255,255,0.1)" dark>20% unter Ø Rot | 20% über Ø Grün</v-chip>
      </v-card-title>
      <v-data-table
        dark
        :mobile-breakpoint="mobileTableMode"
        :loading="!finishedLoadingElevenDaysData"
        :headers="elevenDaysHeaders"
        :items="elevenDaysData"
        class="elevation-4 rounded-xl modern-table"
        style="background-color: #2a2a2a"
        :items-per-page="8">
        <template v-slot:item.activated="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-chip v-bind="attrs" v-on="on" :color="getDeviationColor(item.activated, averages.activated)" class="font-weight-bold" dark>
                {{ Number(item.activated).toFixed(2) }}
              </v-chip>
            </template>
            <span class="white--text">Ø Aktiviert: {{ Number(averages.activated).toFixed(2) }}</span>
          </v-tooltip>
        </template>

        <template v-slot:item.accepted="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-chip v-bind="attrs" v-on="on" :color="getDeviationColor(item.accepted, averages.accepted)" class="font-weight-bold" dark>
                {{ Number(item.accepted).toFixed(2) }}
              </v-chip>
            </template>
            <span class="white--text">Ø Abgeschlossen: {{ Number(averages.accepted).toFixed(2) }}</span>
          </v-tooltip>
        </template>

        <template v-slot:item.declined="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-chip v-bind="attrs" v-on="on" :color="getDeviationColor(item.declined, averages.declined)" class="font-weight-bold" dark>
                {{ Number(item.declined).toFixed(2) }}
              </v-chip>
            </template>
            <span class="white--text">Ø Kein Abschluss: {{ Number(averages.declined).toFixed(2) }}</span>
          </v-tooltip>
        </template>

        <template v-slot:item.anamnese="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-chip v-bind="attrs" v-on="on" :color="getDeviationColor(item.anamnese, averages.anamnese)" class="font-weight-bold" dark>
                {{ Number(item.anamnese).toFixed(2) }}
              </v-chip>
            </template>
            <span class="white--text">Ø Anamnese: {{ Number(averages.anamnese).toFixed(2) }}</span>
          </v-tooltip>
        </template>

        <template v-slot:item.anamneseEleven="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-chip v-bind="attrs" v-on="on" :color="getDeviationColor(item.anamneseEleven, averages.anamneseEleven)" class="font-weight-bold" dark>
                {{ Number(item.anamneseEleven).toFixed(2) }}
              </v-chip>
            </template>
            <span class="white--text">Ø Anamnese 11 Tage: {{ Number(averages.anamneseEleven).toFixed(2) }}</span>
          </v-tooltip>
        </template>

        <template v-slot:item.quote="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-chip v-bind="attrs" v-on="on" :color="getDeviationColor(item.quote, averages.quote)" class="font-weight-bold" dark>
                {{ Number(item.quote).toFixed(2) }}%
              </v-chip>
            </template>
            <span class="white--text">Ø Quote: {{ Number(averages.quote).toFixed(2) }}%</span>
          </v-tooltip>
        </template>
      </v-data-table>

      <v-card-title class="text-h6 font-weight-bold px-2 mt-8 mb-2">Überstunden und Ferienstunden</v-card-title>
      <v-data-table
        dark
        :mobile-breakpoint="mobileTableMode"
        :headers="overtimeVacationHeaders"
        :items="overtimeVacationItems"
        class="elevation-4 rounded-xl modern-table mb-8"
        style="background-color: #2a2a2a"
        :items-per-page="8">
        <template v-slot:item.percentage="{ item }">
          <v-chip class="font-weight-bold" color="rgba(255,255,255,0.1)" dark>{{ Number(item.percentage).toFixed(2) }}%</v-chip>
        </template>
        <template v-slot:item.overTime="{ item }">
          <v-chip class="font-weight-bold" color="rgba(255,255,255,0.1)" dark v-if="item.overTime !== 'keine hinterlegt'">{{
            Number(item.overTime).toFixed(2)
          }}</v-chip>
          <v-chip class="font-weight-bold" color="rgba(255,255,255,0.1)" dark v-else>keine hinterlegt</v-chip>
        </template>
        <template v-slot:item.vacationHours="{ item }">
          <v-chip class="font-weight-bold" color="rgba(255,255,255,0.1)" dark v-if="item.vacationHours !== 'keine hinterlegt'">
            {{ Number(item.vacationHours).toFixed(2) }}h |
            {{ item.timeTrackerPercentage > 0 ? (item.vacationHours / ((8.4 / 100) * item.timeTrackerPercentage)).toFixed(2) : "0.00" }} Tage
          </v-chip>
          <v-chip class="font-weight-bold" color="rgba(255,255,255,0.1)" dark v-else>keine hinterlegt</v-chip>
        </template>
        <template v-slot:item.vacationDaysCount="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ attrs, on }">
              <v-chip v-bind="attrs" v-on="on" class="font-weight-bold" color="primary" outlined dark
                >{{ Number(item.vacationDaysCount).toFixed(2) }} Tage</v-chip
              >
            </template>
            <div v-for="date in item.vacationDatesList" :key="date.date" class="text-caption white--text">
              {{ $moment(date.date).format("DD.MM.YYYY") + " " + date.reason }}
            </div>
          </v-tooltip>
        </template>
      </v-data-table>

      <v-dialog v-model="showTrainerSelectDialog" max-width="500px">
        <v-card dark color="#2A2A2A" class="rounded-xl">
          <v-card-title class="font-weight-bold pb-2">Ziele bearbeiten</v-card-title>
          <v-card-text class="pt-4">
            <v-menu v-model="monthMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="goalMonth"
                  label="Monat auswählen"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  color="primary"></v-text-field>
              </template>
              <v-date-picker
                v-model="goalMonth"
                type="month"
                @input="
                  monthMenu = false
                  fetchDialogTrainers()
                "
                color="primary"
                dark></v-date-picker>
            </v-menu>

            <v-divider class="my-2" style="border-color: rgba(255, 255, 255, 0.1)"></v-divider>
            <div class="text-subtitle-1 mb-2 font-weight-bold">Trainer auswählen:</div>

            <div v-if="isFetchingDialogTrainers" class="text-center py-6">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </div>

            <v-list dark color="transparent" v-else>
              <v-list-item
                v-for="t in dialogTrainers"
                :key="'dlgt_' + t._id"
                @click="openTargetDialog(t)"
                class="mb-2"
                style="background: rgba(255, 255, 255, 0.05); border-radius: 8px">
                <v-list-item-avatar>
                  <img :src="t.picture ? '/img/profilbilder' + t.picture : '/img/einmalig/imageUploadPlaceholderPFP.jpg'" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold">{{ t.fullName }}</v-list-item-title>
                  <v-list-item-subtitle class="text-caption">
                    <span :class="t.trainerGoal?.goals ? 'green--text' : 'orange--text'">
                      {{ t.trainerGoal?.goals ? "Ziele für diesen Monat hinterlegt" : "Noch keine Ziele" }}
                    </span>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon color="grey">mdi-chevron-right</v-icon>
                </v-list-item-action>
              </v-list-item>
              <div v-if="!dialogTrainers.length" class="text-center grey--text py-4">Keine Trainer für diesen Monat gefunden.</div>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="grey" @click="showTrainerSelectDialog = false">Schliessen</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showTargetDialog" max-width="500px">
        <v-card dark color="#2A2A2A" class="rounded-xl" v-if="selectedTrainerForGoal">
          <v-card-title class="font-weight-bold"
            >Ziele für {{ selectedTrainerForGoal.fullName }}
            <span class="text-caption grey--text ml-2 mt-2">({{ $moment(goalMonth).format("MMM YYYY") }})</span></v-card-title
          >

          <v-row no-gutters class="px-4 mb-4">
            <v-col class="text-center" cols="6">
              <span class="font-weight-bold text-caption grey--text text-uppercase">Sollstunden</span>
              <p class="font-weight-bold primary--text mb-0">{{ workHours }}</p>
            </v-col>
            <v-col class="text-center" cols="6">
              <span class="font-weight-bold text-caption grey--text text-uppercase">Überstunden</span>
              <p class="font-weight-bold primary--text mb-0">
                {{ typeof selectedTrainerForGoal.overTime === "number" ? selectedTrainerForGoal.overTime : "0" }} Stunden
              </p>
            </v-col>
          </v-row>

          <v-card-text>
            <v-form>
              <v-row dense>
                <v-col cols="6"
                  ><v-text-field v-model.number="targets.contracts" label="Verträge" type="number" outlined dense color="primary"
                /></v-col>
                <v-col cols="6"
                  ><v-text-field v-model.number="targets.anamneses" label="Anamnesebögen" type="number" outlined dense color="primary"
                /></v-col>
                <v-col cols="6"
                  ><v-text-field v-model.number="targets.packages" label="Anzahl Pakete" type="number" outlined dense color="primary"
                /></v-col>
                <v-col cols="6"
                  ><v-text-field v-model.number="targets.workouts" label="Trainingspläne" type="number" outlined dense color="primary"
                /></v-col>
                <v-col cols="6"
                  ><v-text-field v-model.number="targets.workoutsPerCustomer" label="Versch. Kunden TP" type="number" outlined dense color="primary"
                /></v-col>
                <v-col cols="6"
                  ><v-text-field v-model.number="targets.interactions" label="Kundeninteraktionen" type="number" outlined dense color="primary"
                /></v-col>
                <v-col cols="12"
                  ><v-text-field v-model.number="targets.upgrades" label="Upgrades" type="number" outlined dense color="primary"
                /></v-col>
                <v-col cols="6"
                  ><v-text-field v-model.number="targets.appointmentsTarget" label="Termine (Ziel)" type="number" outlined dense color="primary"
                /></v-col>
                <v-col cols="6">
                  <div class="appointment-actual-readonly">
                    <v-icon color="primary">{{ appointmentSourceIcon(selectedTrainerForGoal) }}</v-icon>
                    <div>
                      <small>Termine (Ist) · nicht editierbar</small>
                      <strong>{{ appointmentActual(selectedTrainerForGoal) }}</strong>
                      <span>{{ appointmentSourceLabel(selectedTrainerForGoal) }}</span>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text color="grey" @click="showTargetDialog = false">Abbrechen</v-btn>
            <v-btn color="primary" depressed class="rounded-lg px-6 font-weight-bold" @click="saveTargets">Speichern</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import api from "../../../api"
import { mapState } from "vuex"
import userService from "@/services/userService.js"

export default {
  name: "dashboard",
  props: {
    selectedStudioSingle: { type: String },
    datePickerRange: { type: Array },
  },
  data() {
    return {
      userService,
      tab: 0,
      notShownTrainers: [],
      activeSorting: "",
      search: "",
      percentagesTo100: false,
      dashboardTrainerInfos: [],
      finishedLoading: false,
      finishedLoadingTerminations: false,
      finishedLoadingElevenDaysData: false,
      startOfMonth: {},
      newContracts: { totalContracts: 0, publicContracts: 0 },
      terminations: null,
      growthForMonth: null,
      elevenDaysData: [],
      trainerVacations: [],
      totalPercentages: 0,

      // --- Neue Variablen für Mobile Tabellen Ansicht ---
      mobileTableMode: "0",

      // --- Neue Variablen für Trainer Ziele ---
      showTrainerSelectDialog: false,
      showTargetDialog: false,
      monthMenu: false,
      goalMonth: "",
      isFetchingDialogTrainers: false,
      dialogTrainers: [],
      selectedTrainerForGoal: null,
      workHours: "",
      vacationDays: 0,
      targets: {
        contracts: null,
        anamneses: null,
        packages: null,
        workouts: null,
        workoutsPerCustomer: null,
        interactions: null,
        upgrades: null,
        appointmentsTarget: null,
        appointmentsActual: null,
      },

      elevenDaysHeaders: [
        { text: "Trainer", value: "trainer", width: "150px" },
        { text: "Anz. 11 Tage Aktiviert", value: "activated" },
        { text: "Abgeschlossen", value: "accepted" },
        { text: "Kein Abschluss", value: "declined" },
        { text: "Anamnese", value: "anamnese" },
        { text: "Anamnese 11. Tage", value: "anamneseEleven" },
        { text: "Quote", value: "quote" },
        { text: "Quote (studio)", value: "studioQuote" },
      ],
      groupfitnessCoursesTable: [
        { text: "Name", value: "fullName", width: "160px" },
        { text: "Stellenprozent", value: "percentage" },
        { text: "Verträge", value: "contracts" },
        { text: "Pakete", value: "packageCount" },
        { text: "Anamnesebögen", value: "medicalHistory" },
        { text: "Trainingspläne", value: "workouts" },
        { text: "Versch. Kunden TP", value: "workoutsPerCustomer" },
        { text: "Kundeninteraktionen", value: "interactions.totalInteractions" },
        { text: "Termine", value: "appointments" },
        { text: "Upgrades", value: "upgrades" },
      ],
      overtimeVacationHeaders: [
        { text: "Trainer", value: "fullName", width: "150px" },
        { text: "Stellenprozent", value: "percentage" },
        { text: "Überstunden in (h)", value: "overTime" },
        { text: "Ferienstunden", value: "vacationHours" },
        { text: "Urlaubstage im " + this.$moment(this.datePickerRange[0]).format("MMM YY"), value: "vacationDaysCount" },
      ],
    }
  },
  created() {
    this.fetchData()
    this.fetchTerminations()
    this.fetchElevenDaysData()
  },
  methods: {
    toggleMobileTableMode() {
      this.mobileTableMode = this.mobileTableMode === "0" ? "xs" : "0"
    },
    async fetchData() {
      this.finishedLoading = false
      const [data, trainerVacations, dashboardTrainerInfos] = await Promise.all([
        api.fetchMontlyStatistcsForStudioRange(this.selectedStudioSingle, this.datePickerRange),
        api.fetchHolidayEntryEmployeeStudioManagement(this.selectedStudioSingle, "accepted"),
        api.fetchTrainerDashboardInfos({
          studios: [this.selectedStudioSingle],
          range: this.datePickerRange,
          includeAppointmentFacts: true,
          compactTrainerStatistics: true,
        }),
      ])

      this.startOfMonth = data.startOfMonthStat[0]
      this.growthForMonth = data.growthForMonth
      this.newContracts = data.contracts[0] || { totalContracts: 0, publicContracts: 0 }
      this.trainerVacations = trainerVacations
      this.dashboardTrainerInfos = dashboardTrainerInfos
      this.notShownTrainers = this.dashboardTrainerInfos.filter((t) => !t.contracts && !t.workouts && !t.medicalHistory)
      this.finishedLoading = true
    },
    async fetchElevenDaysData() {
      this.finishedLoadingElevenDaysData = false
      try {
        let data = await api.fetchMontlyStatistcsElevenDaysForStudioRange(this.selectedStudioSingle, this.datePickerRange)
        // NaN-Werte direkt bei der API-Antwort abfangen
        this.elevenDaysData = data.map((item) => ({
          ...item,
          quote: isNaN(parseFloat(item.quote)) ? 0 : parseFloat(item.quote),
          studioQuote: isNaN(parseFloat(item.studioQuote)) ? 0 : parseFloat(item.studioQuote),
        }))
      } catch (error) {
        this.$toast.error("Fehler beim Laden der 11 Tage Daten")
      }
      this.finishedLoadingElevenDaysData = true
    },
    async fetchTerminations() {
      this.finishedLoadingTerminations = false
      let data = await api.fetchMonthlyStatistcsForStudioTerminationsRange(this.selectedStudioSingle, this.datePickerRange)
      this.terminations = data.terminations
      this.finishedLoadingTerminations = true
    },

    // --- Methoden für Trainer Ziele ---
    openTrainerSelectDialog() {
      this.goalMonth = this.$moment(this.datePickerRange[0]).format("YYYY-MM")
      this.dialogTrainers = JSON.parse(JSON.stringify(this.filteredDashboardTrainerInfos))
      this.showTrainerSelectDialog = true
    },
    async fetchDialogTrainers() {
      this.isFetchingDialogTrainers = true
      let range = [this.$moment(this.goalMonth).startOf("month").toDate(), this.$moment(this.goalMonth).endOf("month").toDate()]
      let data = await api.fetchTrainerDashboardInfos({
        studios: [this.selectedStudioSingle],
        range: range,
        includeAppointmentFacts: true,
        compactTrainerStatistics: true,
      })
      this.dialogTrainers = data.filter((u) => !u.fullName.toLowerCase().includes("roodytrainer"))
      this.isFetchingDialogTrainers = false
    },
    getVacationDaysForTrainer(trainer, monthStr) {
      // Sicherstellen, dass .dates ein Array ist, um Fehler bei .reduce() zu vermeiden
      const entries = (this.trainerVacations || []).filter((v) => v.employee?.fullName === trainer.fullName && Array.isArray(v.dates))
      return entries.reduce((total, entry) => {
        return (
          total +
          entry.dates.reduce((sum, d) => {
            return this.$moment(d.date).format("YYYY-MM") === monthStr && d.duration > 0 ? sum + d.duration : sum
          }, 0)
        )
      }, 0)
    },
    calcBusinessDaysForMonth(monthStr) {
      let day = this.$moment(monthStr).startOf("month")
      let end = this.$moment(monthStr).endOf("month")
      let businessDays = 0
      while (day.isSameOrBefore(end, "day")) {
        if (day.day() !== 0 && day.day() !== 6) businessDays++
        day.add(1, "d")
      }
      return businessDays
    },
    openTargetDialog(trainer) {
      if (userService.hasRole("616616c4c659c875cad63525") || userService.hasRole("61661791c659c875cad63527")) return

      this.selectedTrainerForGoal = trainer
      this.vacationDays = this.getVacationDaysForTrainer(trainer, this.goalMonth)

      let studio = this.storeStudios.find((s) => s._id === (trainer.mainStudio?._id || trainer.mainStudio || trainer.studio[0]))
      let studioHolidays = 0
      if (studio && studio.vacationDays) {
        studioHolidays = studio.vacationDays.filter(
          (day) => this.$moment(this.goalMonth).format("YYYY-MM") === this.$moment(day.date).format("YYYY-MM"),
        ).length
      }

      let bDays = this.calcBusinessDaysForMonth(this.goalMonth)
      this.workHours = Math.round((bDays - studioHolidays) * ((8.4 * trainer.percentage) / 100) * 1000) / 1000 + " Std. (" + trainer.percentage + "%)"

      if (trainer.trainerGoal && trainer.trainerGoal.goals) {
        this.targets = { ...trainer.trainerGoal.goals }
      } else {
        this.targets = {
          contracts: null,
          anamneses: null,
          packages: null,
          workouts: null,
          workoutsPerCustomer: null,
          interactions: null,
          upgrades: null,
          appointmentsTarget: null,
          appointmentsActual: null,
        }
      }
      this.showTargetDialog = true
    },
    async saveTargets() {
      await api.saveTrainerGoalsForMonth({
        goals: this.targets,
        trainer: this.selectedTrainerForGoal._id,
        month: this.goalMonth,
      })

      let tDialog = this.dialogTrainers.find((t) => t._id === this.selectedTrainerForGoal._id)
      if (tDialog) {
        this.$set(tDialog, "trainerGoal", { month: this.goalMonth, goals: { ...this.targets } })
      }

      if (this.goalMonth === this.$moment(this.datePickerRange[0]).format("YYYY-MM")) {
        let tMain = this.dashboardTrainerInfos.find((t) => t._id === this.selectedTrainerForGoal._id)
        if (tMain) {
          this.$set(tMain, "trainerGoal", { month: this.goalMonth, goals: { ...this.targets } })
        }
      }

      this.$toast.success("Ziele gespeichert")
      this.showTargetDialog = false
    },

    appointmentActual(trainer) {
      if (trainer && trainer.appointmentsActual !== null && trainer.appointmentsActual !== undefined && trainer.appointmentsActual !== "") {
        return Number(trainer.appointmentsActual) || 0
      }
      const legacyValue = trainer?.trainerGoal?.goals?.appointmentsActual
      return legacyValue !== null && legacyValue !== undefined && legacyValue !== "" ? Number(legacyValue) || 0 : 0
    },
    appointmentSource(trainer) {
      if (["manual", "manual_missing", "workcalendar", "mixed", "mixed_missing"].includes(trainer?.appointmentsActualSource)) {
        return trainer.appointmentsActualSource
      }
      const legacyValue = trainer?.trainerGoal?.goals?.appointmentsActual
      return legacyValue !== null && legacyValue !== undefined && legacyValue !== "" ? "manual" : "workcalendar"
    },
    appointmentSourceLabel(trainer) {
      return {
        manual: "Bis 31.07.2026: historisch fest hinterlegter Ist-Wert",
        manual_missing: "Vor August 2026: historischer Ist-Wert fehlt",
        workcalendar: "Ab 01.08.2026: automatisch aus dem WorkCalendar",
        mixed: "Historische Ist-Werte + WorkCalendar ab 01.08.2026",
        mixed_missing: "Gemischt: mindestens ein historischer Ist-Wert fehlt",
      }[this.appointmentSource(trainer)]
    },
    appointmentSourceIcon(trainer) {
      const source = this.appointmentSource(trainer)
      if (["manual_missing", "mixed_missing"].includes(source)) return "mdi-alert-circle-outline"
      if (source === "manual") return "mdi-history"
      if (source === "mixed") return "mdi-source-merge"
      return "mdi-calendar-check-outline"
    },

    getTargetColor(actual, target) {
      if (target == null || target === 0) return "grey"
      const ratio = actual / target
      if (ratio <= 0.5) return "red"
      if (ratio < 1) return "orange"
      return "green"
    },
    getPackageColor(val) {
      if (val > 1.5) return "green"
      if (val < 0.8) return "red"
      return "orange"
    },
    getDeviationColor(value, avg) {
      return ""
      return "grey"
      if (value >= avg * 1.2) return "green"
      if (value <= avg * 0.8) return "red"
      return "orange"
    },
  },
  computed: {
    ...mapState("studioStore", ["storeStudios"]),
    overtimeVacationItems() {
      const start = this.$moment(this.datePickerRange[0]).startOf("month")
      const end = this.$moment(this.datePickerRange[0]).endOf("month")
      return this.dashboardTrainerInfos.map((trainer) => {
        const vacEntries = (this.trainerVacations || []).filter((v) => v.employee.fullName === trainer.fullName && v.dates?.length > 0)
        let vacationDatesList = []
        vacEntries.forEach((entry) => {
          entry.dates.forEach((d) => {
            if (this.$moment(d.date).isBetween(start, end, "day", "[]")) {
              if (d.duration > 0) vacationDatesList.push({ date: d.date, reason: entry.reason || "kein Grund angegeben" })
            }
          })
        })
        return {
          fullName: trainer.fullName,
          percentage: trainer.percentage,
          timeTrackerPercentage: trainer.timeTrackerPercentage || trainer.percentage || 100, // Fallback gegen Division durch Null
          overTime: typeof trainer.overTime === "number" ? trainer.overTime : "keine hinterlegt",
          vacationHours: typeof trainer.mainStudio?.vacationHours === "number" ? trainer.mainStudio.vacationHours : "keine hinterlegt",
          vacationDaysCount: vacationDatesList.length,
          vacationDatesList,
        }
      })
    },
    averages() {
      if (!this.elevenDaysData || !this.elevenDaysData.length)
        return { activated: 0, accepted: 0, declined: 0, anamnese: 0, anamneseEleven: 0, quote: 0, studioQuote: 0 }
      const sums = this.elevenDaysData.reduce(
        (acc, cur) => {
          acc.activated += cur.activated || 0
          acc.accepted += cur.accepted || 0
          acc.declined += cur.declined || 0
          acc.anamnese += cur.anamnese || 0
          acc.anamneseEleven += cur.anamneseEleven || 0
          acc.quote += parseFloat(cur.quote) || 0
          acc.studioQuote += cur.studioQuote || 0
          return acc
        },
        { activated: 0, accepted: 0, declined: 0, anamnese: 0, anamneseEleven: 0, quote: 0, studioQuote: 0 },
      )
      const len = this.elevenDaysData.length || 1
      return {
        activated: sums.activated / len,
        accepted: sums.accepted / len,
        declined: sums.declined / len,
        anamnese: sums.anamnese / len,
        anamneseEleven: sums.anamneseEleven / len,
        quote: sums.quote / len,
        studioQuote: sums.studioQuote / len,
      }
    },
    filteredDashboardTrainerInfos() {
      let arr = JSON.parse(JSON.stringify(this.dashboardTrainerInfos))
      let totalPercentages = 0
      arr = arr.map((u) => {
        u.studio = u.studio.map((id) => this.storeStudios.find((s) => s._id === id)?.name || "zus. Team").join(", ")
        totalPercentages += u.allPercentages.find((p) => p._id === this.selectedStudioSingle)?.percentage || 0
        if (this.percentagesTo100 && u.percentage < 100) {
          u.contracts = parseFloat(((u.contracts / u.percentage) * 100).toFixed(2))
          u.interactions.totalInteractions = parseFloat(((u.interactions.totalInteractions / u.percentage) * 100).toFixed(2))
          u.medicalHistory = parseFloat(((u.medicalHistory / u.percentage) * 100).toFixed(2))
          u.workouts = parseFloat(((u.workouts / u.percentage) * 100).toFixed(2))
          u.workoutsPerCustomer = parseFloat(((u.workoutsPerCustomer / u.percentage) * 100).toFixed(2))
          u.upgrades = parseFloat(((u.upgrades / u.percentage) * 100).toFixed(2))
          u.percentage = 100
        }
        return u
      })
      arr = arr.filter((u) => !u.fullName.toLowerCase().includes("roodytrainer"))
      if (this.activeSorting) {
        arr.sort((a, b) => b[this.activeSorting] - a[this.activeSorting])
      }
      this.totalPercentages = totalPercentages
      return arr
    },
  },
  watch: {
    async selectedStudioSingle() {
      this.fetchData()
      this.fetchTerminations()
      this.fetchElevenDaysData()
    },
    async datePickerRange() {
      if (this.datePickerRange[0] && this.datePickerRange[1]) {
        this.fetchData()
        this.fetchTerminations()
        this.fetchElevenDaysData()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .apexcharts-menu-open {
  background-color: #212121 !important;
  height: 80vh;
}

.dashboard-card {
  position: relative;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  border: 1px solid rgba(255, 255, 255, 0.05) !important;
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.4) !important;
  }
}

.card-label {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #9e9e9e;
  font-weight: 700;
  line-height: 1.2;
}

.accent-line {
  position: absolute;
  bottom: 0;
  left: 20px;
  right: 20px;
  height: 3px;
  border-radius: 3px 3px 0 0;
  opacity: 0.9;
}

.modern-table {
  border: 1px solid rgba(255, 255, 255, 0.05) !important;

  ::v-deep .v-data-table__wrapper {
    overflow-x: auto !important;
  }

  ::v-deep th {
    text-transform: uppercase;
    font-size: 0.75rem !important;
    letter-spacing: 0.5px;
    color: #9e9e9e !important;
    white-space: nowrap !important;
  }

  ::v-deep td {
    white-space: nowrap !important;
    padding: 0 16px !important;
  }
}

.appointment-actual-readonly {
  display: flex;
  min-height: 64px;
  align-items: center;
  gap: 12px;
  padding: 9px 12px;
  border: 1px solid rgba(33, 150, 243, 0.35);
  border-radius: 8px;
  background: rgba(33, 150, 243, 0.08);

  > div {
    display: flex;
    min-width: 0;
    flex-direction: column;
  }

  small,
  span {
    color: #90a4ae;
    font-size: 0.68rem;
    line-height: 1.25;
  }

  strong {
    margin: 1px 0;
    color: white;
    font-size: 1.15rem;
  }
}
</style>
